import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FilesUploadingProps from '../data/filesUploadingProps';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import { capitalizeFirstLetter, checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import { coveragePlans } from '../data/coveragePlan';
import history from '../utils/history';
import IconDoc from '../assets/icon-docu.svg';
import IconEye from '../assets/ic_eye_blue.svg';
import RimacTag from '../components/common/RimacTag/RimacTag';
import SplitLayout from '../layout/SplitLayout';
import IconDocument from '../assets/ic_drop_doc.svg';
import InfoCard from '../components/content/InfoCard/InfoCard';
import IconInfo from '../assets/infoIcon.svg';
import { DELAY_OUT_TOOLTIP, PAGINAS_BY_STEP, TOOLTIP_MESSAGES } from '../utils/constants';
import Tooltip from '../components/common/tooltip';

const BeforeStartPage = () => {
  const [viewStartTime] = useState(new Date());
  const [tooltipActive, setTooltipActive] = useState(true);
  const dispatch = useDispatch();
  const advisorInfo = useSelector( (state) => state.sinisterCards.advisorInfo)
  const sinisterList = useSelector((state) => state.sinisterCards.sinisterList);
  const currentCoveragePlan = useSelector(
    (state) => state.coverages.currentPlan
  );
  const currentUser = useSelector((state) => state.sinisterCards.userInfo);
  const currentUserName = `${capitalizeFirstLetter(
    currentUser?.name ?? ''
  )} ${capitalizeFirstLetter(currentUser?.fatherLastName ?? '')}`;
  const isOtherBanksCoverageSelected = sinisterList.find(
    (sinister) => sinister.code === 'COB04'
  );
  const { listFiles } = FilesUploadingProps;
  const isSecondServiceSelected = sinisterList.find(
    (item) => item.code === 'COB02'
  );
  const isThirdServiceSelected = sinisterList.find(
    (item) => item.code === 'COB03'
  );
  const isOtherCovergeSelected = sinisterList.find(
    (item) => item.code === 'OTRO_SINIESTRO'
  );
  const requiredDocuments = listFiles.filter((file) => file.id !== '6');

  if (isSecondServiceSelected && sinisterList.length === 1) {
    requiredDocuments.pop();
  }

  if (isThirdServiceSelected) {
    requiredDocuments.push(listFiles.find((type) => type.id === '6'));
  }

  useEffect(() => {
    setTimeout(() => {
      setTooltipActive(false);
    }, DELAY_OUT_TOOLTIP);
  }, []);

  useEffect(() => {
    if (!viewStartTime) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const endTime = new Date();
    const userTotalTime = timeBetweenDates(viewStartTime, endTime);

    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        task: {
          name: 'Tiempo registrado - Antes de comenzar',
          time: userTotalTime,
        },
        event: 'trackTimeToComplete',
      });
    }
  }, [viewStartTime]);

  const onBackHandler = () => {
    if (isOtherCovergeSelected) {
      dispatch(sinisterCardsActions.setStep({step: PAGINAS_BY_STEP.DESCRIPCION_OTRO_SINIESTRO.step, plan: currentCoveragePlan}));
      history.replace(`/${coveragePlans[currentCoveragePlan].uri}/otro-caso`);
      return;
    }

    if (isOtherBanksCoverageSelected) {
      dispatch(sinisterCardsActions.setStep({step: PAGINAS_BY_STEP.OTRO_SEGURO.step, plan: currentCoveragePlan}));
      history.replace(`/${coveragePlans[currentCoveragePlan].uri}/otros-seguros`);
      return;
    }
    dispatch(sinisterCardsActions.setStep({step: PAGINAS_BY_STEP.DETALLE_SINIESTRO.step, plan: currentCoveragePlan}));
    history.replace(`/${coveragePlans[currentCoveragePlan].uri}/detalle-siniestro`);
  };

  const onContinueHandler = () => {
    dispatch(sinisterCardsActions.incrementStep());
    history.replace(`/${coveragePlans[currentCoveragePlan].uri}/documentos-requeridos`);
  };

  const onShowExample = (doc) => {
    if (checkIfHotjarEnable()) {
      // LAST
      window.digitalData.push({
        "action": {
          "group": "Tramites Siniestros - Protección Tarjeta BBVA",
          "category": `Para comenzar - ${capitalizeFirstLetter(currentCoveragePlan.toLowerCase())}`,
          "name": "Ver ejemplo",
          "label": doc.title
        },
        "event":"trackAction"
      });
    }
  }

  const leftContent = (
    <>
      <RimacTag
        customClasses="u-mb-8"
        color={coveragePlans[currentCoveragePlan].color}
        text={coveragePlans[currentCoveragePlan].name}
      />
      <div className="titleCont">
        <h1 className="u-mb-40">Seguro de Protección de Tarjetas</h1>
        <p>
          <span className="u-font-bold">{currentUserName}</span>, estás
          solicitando:
        </p>
        <ul className="rimacCardCont">
          {sinisterList.map((cov) => (
            <div key={cov.code} className="rimacLiteCard u-mb-8">
              <img
                className="rimacLiteCard__img"
                src={cov.icon}
                alt={cov.title}
              />
              <p className="rimacLiteCard__title">{cov.title}</p>
            </div>
          ))}
        </ul>
      </div>
    </>
  );

  const rightContent = (
    <>
      <RimacTag
        customClasses="u-mb-16 mobile"
        color={coveragePlans[currentCoveragePlan].color}
        text={coveragePlans[currentCoveragePlan].name}
      />
      <div className="titleCont">
        <h3 className="u-mb-16">
          ¡Para comenzar!{' '}
          <Tooltip
            title="Importante"
            description={TOOLTIP_MESSAGES.MSG_3}
            active={tooltipActive}
            hidden={!advisorInfo}
          >
            <img src={IconInfo} />
          </Tooltip>
        </h3>
        <p className="u-mb-40">
          Necesitas digitalizar <b>(Tomar una foto o escanear)</b> los
          siguientes documentos:
        </p>
        <InfoCard
          icon={IconInfo}
          customClasses={'u-mb-40'}
          content={
            <p>
              <b>Recuerda:</b><br />Los documentos pueden ser originales o copias simples, excepto la denuncia policial, que debe ser original o copia certificada.
            </p>
          }
        />

        <ul data-testid="documents-list">
          {requiredDocuments.map((doc, i) => (
            <li className="u-mb-16 listItem" key={`doc-${i}`}>
              <div className="listItem__left">
                <img src={IconDocument} alt="documento a registrar" />
              </div>
              <div className="listItem__right">
                <span className="left">
                  <img src={IconDoc} alt="documento a registar" />
                  <span>
                    <span>{doc.title}</span>
                    {doc.id === '6' && <p>Se puede adjuntar más adelante</p>}
                    {/* {doc.id === '2' && <p>Debes realizarla de forma presencial en la comisaría del distrito donde ocurrió el hecho.</p>} */}
                    {doc.id === '4' && <p>Los consumos no reconocidos deben estar procesados.</p>}
                    {doc.id === '5' && <p>Los movimientos no reconocidos deben estar procesados.</p>}
                    <a
                      className="link"
                      href={doc.docUrl}
                      onClick={ e => onShowExample(doc)}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={IconEye} alt="descarga un ejemplo aquí" />
                      <p>Ver ejemplo</p>
                    </a>
                  </span>
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  );

  return (
    <SplitLayout
      dataTestId='before-start-page'
      containerClasses="beforeStartPage"
      leftClasses="beforeStartPage__left"
      rightClasses="beforeStartPage__right"
      leftContent={leftContent}
      rightContent={rightContent}
      onNavBackClick={onBackHandler}
      onNavContinueClick={onContinueHandler}
      navCurrentStep={2}
      navTotalSteps={5}
      navStepperText={'PASO 2 DE 5'}
      navBtnText="Continuar"
    ></SplitLayout>
  );
};

export default BeforeStartPage;
